import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timeline_wrapper" }
const _hoisted_2 = { class: "timeline-item-label" }
const _hoisted_3 = { class: "timeline-item" }
const _hoisted_4 = ["onClick", "innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "added-note-holder"
}
const _hoisted_8 = ["onClick", "title"]
const _hoisted_9 = {
  key: 1,
  class: "added-note-holder"
}
const _hoisted_10 = ["onClick", "title"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 点击上传 ")
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "Ctrl-V / Cmd-V"),
  /*#__PURE__*/_createTextVNode(" 可快速粘贴截图 ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("添加链接")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_timeline, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entity.state_list, (state, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "hw-timeline-item",
            key: index
          }, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_a_tooltip, { placement: "bottom" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(state.show_long_time), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(state.show_time), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _createVNode(_component_a_timeline_item, {
              color: state.color
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_row, { class: "timeline-item-body" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 24,
                        class: "timeline-item-user"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_a_tag, { color: "orange" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(state.state_group_name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (_ctx.isGod || _ctx.isDev)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                style: _normalizeStyle(`cursor: pointer; ${state.desc_style}`),
                                onClick: ($event: any) => (_ctx.godEditState(state)),
                                innerHTML: state.state_desc
                              }, null, 12, _hoisted_4))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                style: _normalizeStyle(`${state.desc_style}`),
                                innerHTML: state.state_desc
                              }, null, 12, _hoisted_5)),
                          _createElementVNode("span", {
                            class: _normalizeClass({
                    'timeline-item-user-span_group': true,
                    'timeline-item-user-span_group_block': state.span_show,
                  })
                          }, [
                            _withDirectives(_createVNode(_component_svg_icon, {
                              "icon-name": "EditOutlined",
                              onClick: ($event: any) => (_ctx.openUploadEntityFileDialog(state, 'edit'))
                            }, null, 8, ["onClick"]), [
                              [_vShow, !_ctx.readOnly && state.can_edit]
                            ]),
                            _withDirectives(_createVNode(_component_svg_icon, {
                              "icon-name": "PlusOutlined",
                              onClick: ($event: any) => (_ctx.openUploadEntityFileDialog(state, 'add'))
                            }, null, 8, ["onClick"]), [
                              [_vShow, !_ctx.readOnly && state.can_add]
                            ]),
                            _withDirectives(_createVNode(_component_svg_icon, {
                              "icon-name": "MessageOutlined",
                              onClick: ($event: any) => (_ctx.openEditStateNoteDialog(state, 'comment'))
                            }, null, 8, ["onClick"]), [
                              [_vShow, 
                      !_ctx.readOnly &&
                      (state.can_comment ||
                        (!state.can_edit && !state.can_add && _ctx.hasPermission('CanUploadApprovalFlow')))
                    ]
                            ]),
                            _withDirectives(_createVNode(_component_svg_icon, {
                              "icon-name": "UploadOutlined",
                              onClick: ($event: any) => (_ctx.openUploadEntityFileDialog(state, 'comment'))
                            }, null, 8, ["onClick"]), [
                              [_vShow, 
                      !_ctx.readOnly &&
                      (state.can_comment ||
                        (!state.can_edit && !state.can_add && _ctx.hasPermission('CanUploadApprovalFlow')))
                    ]
                            ]),
                            _withDirectives(_createVNode(_component_svg_icon, {
                              "icon-name": "AlertOutlined",
                              onClick: ($event: any) => (_ctx.handle_alert(state))
                            }, null, 8, ["onClick"]), [
                              [_vShow, (!_ctx.readOnly && state.can_alert && !_ctx.hasPermission('RoleFinanceDataViewer')) || _ctx.isGod]
                            ])
                          ], 2)
                        ]),
                        _: 2
                      }, 1024),
                      (state.note || state.added_note_list.length !== 0)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 24,
                            class: "timeline-item-content"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.modifyNote(state)),
                                class: _normalizeClass({
                    'note-block': !_ctx.entity.collapsed,
                    'note-collapsed': _ctx.entity.collapsed,
                  })
                              }, _toDisplayString(state.note), 11, _hoisted_6),
                              (!_ctx.entity.collapsed && state.added_note_list.filter((x) => !x.is_comment))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.added_note_list.filter((x) => !x.is_comment), (an, i) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        onClick: ($event: any) => (_ctx.modifyAddedNote(an)),
                                        class: "note-block note-added",
                                        title: an.create_time,
                                        key: i
                                      }, _toDisplayString(an.note), 9, _hoisted_8))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (!_ctx.entity.collapsed && state.added_note_list.filter((x) => x.is_comment))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.added_note_list.filter((x) => x.is_comment), (an, i) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        onClick: ($event: any) => (_ctx.modifyAddedNote(an)),
                                        class: "note-block note-comment",
                                        title: an.create_time,
                                        key: i
                                      }, _toDisplayString(_ctx.userMap[an.owner_id].name + ': ' + an.note), 9, _hoisted_10))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (state.file_list.length > 0)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            span: 24,
                            class: "timeline-item-file"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: _normalizeClass(["timeline-item-file_group", {
                    'note-block': !_ctx.entity.collapsed,
                    'note-collapsed': _ctx.entity.collapsed,
                  }])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.file_list, (file, fileIndex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: fileIndex,
                                    class: "timeline-item-file_item"
                                  }, [
                                    _createVNode(_component_svg_icon, {
                                      "icon-name": _ctx.FILE_ICON_MAP[_ctx.getFileType(file)]
                                    }, null, 8, ["icon-name"]),
                                    (!('img' === _ctx.getFileType(file) || 'pdf' === _ctx.getFileType(file)))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.openFile(file)),
                                          class: _normalizeClass(file.is_added ? 'file-link-added' : file.is_comment ? 'file-link-comment' : 'file-link')
                                        }, _toDisplayString((file.is_comment ? _ctx.userMap[file.owner_id].name + ': ' : '') + file.file_name), 11, _hoisted_11))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.openFile(file, true)),
                                          class: _normalizeClass(file.is_added ? 'file-link-added' : file.is_comment ? 'file-link-comment' : 'file-link')
                                        }, _toDisplayString((file.is_comment ? _ctx.userMap[file.owner_id].name + ': ' : '') + file.file_name), 11, _hoisted_12)),
                                    ('link' !== _ctx.getFileType(file))
                                      ? (_openBlock(), _createBlock(_component_svg_icon, {
                                          key: 2,
                                          "icon-name": "DownloadOutlined",
                                          onClick: ($event: any) => ('img' === _ctx.getFileType(file) ? _ctx.downloadPic(file) : _ctx.openFile(file))
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createVNode(_component_svg_icon, {
                                      "icon-name": "CloseOutlined",
                                      onClick: ($event: any) => (_ctx.deleteEntityFile(file))
                                    }, null, 8, ["onClick"]), [
                                      [_vShow, _ctx.isAdmin || (!_ctx.readOnly && state.can_edit)]
                                    ])
                                  ]))
                                }), 128))
                              ], 2)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1032, ["color"])
          ]))
        }), 128))
      ]),
      _: 3
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.editStateNoteDialog,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editStateNoteDialog) = $event)),
      centered: "",
      width: "600px",
      maskClosable: false
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.editStateNoteData.title), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, { onClick: _ctx.closeEditStateNote }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.saveStateNote
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "评论内容" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          placeholder: "请输入",
                          value: _ctx.editStateNoteForm.note,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editStateNoteForm.note) = $event)),
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.noteChanged = true))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.editStateNoteForm.method === 'comment')
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 0,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.editStateNoteData.sendLarkTip
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.editStateNoteForm.send_lark,
                              "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editStateNoteForm.send_lark) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.uploadEntityFileDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uploadEntityFileDialog) = $event)),
      width: "600px",
      centered: "",
      afterClose: _ctx.afterCloseFileDialog,
      maskClosable: false
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.uploadEntityFileData.title), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, { onClick: _ctx.addExternalLink }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, { onClick: _ctx.closeUploadEntityFileDialog }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          disabled: _ctx.uploadEntityFileDisabled,
          type: "primary",
          onClick: _ctx.uploadEntityFile
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          labelAlign: "right",
          labelCol: { style: 'width: 120px' },
          wrapperCol: { style: 'max-width: calc(100% - 120px)' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                (_ctx.uploadEntityFileData.method !== 'comment')
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 0,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "状态备注" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: _ctx.uploadEntityFileData.note,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.uploadEntityFileData.note) = $event)),
                              placeholder: "请输入",
                              rows: 8
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "选择文件" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_upload, {
                          action: _ctx.uploadEntityFileData.url,
                          multiple: true,
                          fileList: _ctx.filesList,
                          customRequest: _ctx.hwSelectFile
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-name": "UploadOutlined" }),
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["action", "fileList", "customRequest"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_form_item, { label: "添加链接" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadEntityFileLinks, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_form, {
                              ref: "linkContainers",
                              class: "add-link-container",
                              model: item,
                              rules: _ctx.fileLinkRules,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { class: "delete-file-links-svg" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, {
                                      onClick: ($event: any) => (_ctx.deleteUploadEntityFileLinks(index)),
                                      "icon-name": "CloseOutlined"
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          name: "link_name",
                                          label: "链接名称",
                                          style: {"word-break":"break-word"}
                                        }, {
                                          default: _withCtx(() => [
                                            (item.resolve_success)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.link_name), 1))
                                              : (_openBlock(), _createBlock(_component_a_input, {
                                                  key: 1,
                                                  value: item.link_name,
                                                  "onUpdate:value": ($event: any) => ((item.link_name) = $event),
                                                  placeholder: "请输入链接名称"
                                                }, null, 8, ["value", "onUpdate:value"]))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 24,
                                      style: {"margin-top":"4px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          name: "link_address",
                                          label: "链接地址"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input, {
                                              placeholder: "请输入链接地址*",
                                              value: item.link_address,
                                              "onUpdate:value": ($event: any) => ((item.link_address) = $event),
                                              onBlur: ($event: any) => (_ctx.analyzeUrl(item.link_address, index))
                                            }, null, 8, ["value", "onUpdate:value", "onBlur"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["model", "rules"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.uploadEntityFileLinks.length !== 0]
                ]),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "提示" }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["wrapperCol"])
      ]),
      _: 1
    }, 8, ["visible", "afterClose"])
  ]))
}